var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "is-flex is-justify-content-space-between" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Phones")]),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.phones.length < 4,
                expression: "phones.length < 4",
              },
            ],
            staticClass: "button is-small is-primary is-light",
            class: `is-light-btn-${_vm.$theme.name}`,
            on: { click: _vm.addTmpPhone },
          },
          [_vm._m(0)]
        ),
      ]),
      _vm._l(_vm.phones, function (assetPhone, index) {
        return _c("div", { key: index, staticClass: "field has-addons" }, [
          _c("div", { staticClass: "control" }, [
            _c("span", { staticClass: "select" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: assetPhone.type,
                      expression: "assetPhone.type",
                    },
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: "Duplicate Type",
                        theme: "danger",
                        enabled: !_vm.$v.uniquePhoneType,
                      },
                      expression:
                        "{ content: 'Duplicate Type', theme: 'danger', enabled: !$v.uniquePhoneType }",
                    },
                  ],
                  class: { "is-invalid": !_vm.$v.uniquePhoneType },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        assetPhone,
                        "type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.phoneTypes, function (type, typeIndex) {
                  return _c(
                    "option",
                    {
                      key: typeIndex,
                      domProps: { value: type.toString() },
                      on: {
                        change: function ($event) {
                          return _vm.$v.phones.types.touch()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(typeIndex) + " ")]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "control is-expanded" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: assetPhone.no,
                  expression: "assetPhone.no",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.$v.phones.$each[index].no.$error },
              attrs: { type: "text" },
              domProps: { value: assetPhone.no },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(assetPhone, "no", $event.target.value)
                  },
                  function ($event) {
                    return _vm.$v.phones.$each[index].no.$touch()
                  },
                ],
              },
            }),
            !_vm.$v.phones.$each[index].no.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Phone number is required "),
                ])
              : _vm._e(),
          ]),
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button has-text-gold",
                attrs: { title: [assetPhone.isDefault ? "Default Phone" : ""] },
                on: {
                  click: function ($event) {
                    return _vm.setDefault(assetPhone)
                  },
                },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c(
                    "span",
                    {
                      staticClass: "mso mso-24px",
                      class: [assetPhone.isDefault ? "mso-fill" : ""],
                    },
                    [_vm._v(" star ")]
                  ),
                ]),
              ]
            ),
          ]),
          _c("p", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button has-text-danger",
                on: {
                  click: function ($event) {
                    return _vm.removePhone(assetPhone)
                  },
                },
              },
              [_vm._m(1, true)]
            ),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" add ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "mso mso-24px" }, [_vm._v(" delete ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }